import ControllerBase from '../../../../global/js/ControllerBase';
import { ProductGalleryItemTypes } from './m-product-gallery.data';
import { MoleculeProductGalleryEvents, MoleculeProductGalleryEventTypes } from './m-product-gallery.events';

interface ComponentRefs {
	galleryWrapper: 'galleryWrapper',
	sliderWrapper: 'sliderWrapper',
	sliderList: 'sliderList',
	openModalButton: 'openModalButton',
}

export default class ControllerProductGallery extends ControllerBase<ComponentRefs> {
	private static readonly componentRefs: ComponentRefs = {
		galleryWrapper: 'galleryWrapper',
		sliderWrapper: 'sliderWrapper',
		sliderList: 'sliderList',
		openModalButton: 'openModalButton'
	}
	private galleryWrapper: HTMLDivElement;
	private galleryItems: HTMLDivElement[] = [];
	private currentThumbIndexSelected: number;
	private sliderWrapper: HTMLDivElement;
	private sliderList: HTMLUListElement;
	private slides: HTMLAnchorElement[] = [];
	private sliderWrapperWidth = 0 as number;
	private sliderListWidth = 0 as number;
	private sliderListWidth2 = 0 as number;
	private sliderListElements = [] as number[];
	private sliderListElements2 = [] as number[];
	private openModalButton: HTMLButtonElement;
	private sliderWrapperHeight = 0 as number;
	private modalProducGallery: HTMLDivElement;
	private sliderList2: HTMLUListElement;

	constructor(element: HTMLElement) {
		super(element, [], Object.values(ControllerProductGallery.componentRefs));

		this.galleryWrapper = this.$references.galleryWrapper as HTMLDivElement;
		if (this.galleryWrapper) {
			this.galleryItems = Array.from<HTMLDivElement>(this.galleryWrapper.querySelectorAll('div.js-focus'));
		}

		this.sliderWrapper = this.$references.sliderWrapper as HTMLDivElement;
		if (this.sliderWrapper) {
			this.slides = Array.from<HTMLAnchorElement>(this.sliderWrapper.querySelectorAll('ul li a.js-thumb'));
			this.sliderWrapperWidth = this.sliderWrapper.clientWidth;
			this.sliderWrapperHeight = this.sliderWrapper.clientHeight;
		}

		this.sliderList = this.$references.sliderList as HTMLUListElement;

		this.init();
		this.galleryPositionHandler();

		this.openModalButton = document.querySelector('a[data-ref="openModalButton"]') as HTMLButtonElement;
		this.openModalButton?.addEventListener('click', () => this.galleryPositionHandlerFullwidth());
		this.galleryPositionHandlerFullwidth()
	}

	private init(): void {
		this.observeSlideThumbClicks();
	}

	private observeSlideThumbClicks(): void {
		this.slides.forEach(slide => {
			slide.addEventListener('click', e => this.slideClick(e));
		});
	}

	private slideClick(event: Event | MouseEvent): void {
		event.preventDefault();

		const currentAnchor = event.currentTarget as HTMLAnchorElement;
		const thumbIndex = parseInt((currentAnchor.dataset.index as string));
		const type = currentAnchor.dataset.type || 'none';

		// break early if user clicks the same thumb...do nothing
		if (this.currentThumbIndexSelected === thumbIndex) return;


		// update selected appearance
		this.updateSelectedThumb(currentAnchor);

		// show new item
		this.updateVisibleGalleryItem(thumbIndex);

		// remember new thumb index
		this.currentThumbIndexSelected = thumbIndex;

		// emit change event for listeners
		this.dispatchCustomEvent<MoleculeProductGalleryEventTypes['thumbnailChanged']>(MoleculeProductGalleryEvents.thumbnailChanged, this.currentThumbIndexSelected, true, true);

		// show the content based on the data type
		switch (type) {
			case ProductGalleryItemTypes.Image: {
				break;
			}
			case ProductGalleryItemTypes.Video: {
				break;
			}
			case ProductGalleryItemTypes.ThreeSixty: {
				// re-init 360?
				// console.log('reinit 360');
				(window as any).CI360 && (window as any).CI360.destroy();
				(window as any).CI360 && (window as any).CI360.init();
				break;
			}
			default: console.log('Invalid product gallery type');
		}
	}

	/**
	 * Remove selected appearance from thumbs and add newly selected appearance, if anchor provided
	 * @param  {HTMLAnchorElement} newSelected?
	 * @returns void
	 */
	private updateSelectedThumb(newSelected?: HTMLAnchorElement): void {
		this.slides.forEach(thumb => {
			thumb.classList.remove('selected');
		});
		if (newSelected) {
			newSelected.classList.add('selected');
		}
	}

	/**
	 * Hide current gallery item and show new one by index
	 * @param  {number} newIndex
	 * @returns void
	 */
	private updateVisibleGalleryItem(newIndex: number): void {
		this.galleryItems.forEach(item => {
			// hide current visible item
			if (item.hasAttribute('hidden') === false) {
				item.setAttribute('hidden', 'true');
			}
			// item.style.opacity = '0';
		});

		if (newIndex >= 0 && this.galleryItems.length >= newIndex) {
			// show new item
			this.galleryItems[newIndex].removeAttribute('hidden');

			// this.galleryItems[newIndex].style.opacity = '1';
			// const foo = this.galleryItems[newIndex].querySelector('div.cloudimage-360');
			// const e = e.dispatchEvent(new CustomEvent('dragStart'));
		}
	}


	private galleryPositionHandler(): void {
		if (this.sliderList) {
			this.sliderList.children.length > 0 && Array.from(this.sliderList.children)
				?.forEach(element => this.sliderListElements?.push(element?.clientHeight));
			this.sliderListWidth = this.sliderListElements.reduce((acc, cur) => acc + cur, 0);
			this.sliderWrapperWidth > this.sliderListWidth
				? this.sliderWrapper.setAttribute('data-position', 'list-centered')
				: this.sliderWrapper.setAttribute('data-position', 'list-left')
		}
	}


	private galleryPositionHandlerFullwidth(): void {
		this.modalProducGallery = document.querySelector('.uk-modal-full.o-product-gallery-360__modalFullWrapper [data-ref="sliderWrapper"]') as HTMLDivElement;
		this.sliderList2 = document.querySelector('.uk-modal-full.o-product-gallery-360__modalFullWrapper [data-ref="sliderList"]') as HTMLUListElement;
		if (this.modalProducGallery && this.sliderList2) {
			setTimeout(() => {
				this.sliderWrapperHeight = this.modalProducGallery.clientHeight;
				this.sliderList2.children.length > 0 && Array.from(this.sliderList2.children)
					?.forEach(element => this.sliderListElements2?.push(element?.clientHeight));
				this.sliderListWidth2 = this.sliderListElements2.reduce((acc, cur) => acc + cur, 0);
				this.sliderWrapperHeight > this.sliderListWidth2
					? this.modalProducGallery.setAttribute('data-vertical-position', 'list-middle')
					: this.modalProducGallery.setAttribute('data-vertical-position', 'list-top')

			}, 50);
		}
	}

}
